import { render, staticRenderFns } from "./CancelOrderModal.vue?vue&type=template&id=56da99fb"
import script from "./CancelOrderModal.vue?vue&type=script&lang=js"
export * from "./CancelOrderModal.vue?vue&type=script&lang=js"
import style0 from "./CancelOrderModal.vue?vue&type=style&index=0&id=56da99fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports